import type { InventoryItem, StockMovement, Warehouse } from './types';
import { ItemCategory, MovementType, StockStatus } from './types';

export const MOCK_WAREHOUSES: Warehouse[] = [
  {
    id: 'wh1',
    name: 'Központi raktár',
    code: 'KR',
    address: 'Budapest, Ipari út 15.',
    isDefault: true,
  },
  {
    id: 'wh2',
    name: 'Üzlet raktár',
    code: 'UR',
    address: 'Budapest, Fő utca 8.',
    isDefault: false,
  },
];

export const MOCK_INVENTORY: InventoryItem[] = [
  // Elektromos szerszámok
  {
    id: 'inv1',
    sku: 'MAK-DHP486',
    barcode: '0088381736275',
    name: 'Makita DHP486 Akkus fúró-csavarozó',
    description: '18V LXT, ütvefúró funkció, 2x5.0Ah akku + töltő',
    category: ItemCategory.POWER_TOOL,
    brand: 'Makita',
    unit: 'db',
    currentStock: 12,
    reservedStock: 3,
    availableStock: 9,
    minStock: 5,
    maxStock: 20,
    purchasePrice: 65000,
    sellingPrice: 89990,
    rentalPriceDaily: 3500,
    vatRate: 27,
    warehouseId: 'wh1',
    warehouseName: 'Központi raktár',
    location: 'A-12-3',
    status: StockStatus.IN_STOCK,
    isRentable: true,
    isSellable: true,
    lastStockUpdate: '2024-01-18T08:30:00',
    lastInventoryCheck: '2024-01-15T14:00:00',
  },
  {
    id: 'inv2',
    sku: 'MAK-GA5030',
    barcode: '0088381095358',
    name: 'Makita GA5030 Sarokcsiszoló 125mm',
    description: '720W, 11000 ford/perc',
    category: ItemCategory.POWER_TOOL,
    brand: 'Makita',
    unit: 'db',
    currentStock: 8,
    reservedStock: 2,
    availableStock: 6,
    minStock: 3,
    maxStock: 15,
    purchasePrice: 18000,
    sellingPrice: 24990,
    rentalPriceDaily: 2000,
    vatRate: 27,
    warehouseId: 'wh1',
    warehouseName: 'Központi raktár',
    location: 'A-12-5',
    status: StockStatus.IN_STOCK,
    isRentable: true,
    isSellable: true,
    lastStockUpdate: '2024-01-17T16:45:00',
  },
  {
    id: 'inv3',
    sku: 'MAK-HR2470',
    barcode: '0088381081689',
    name: 'Makita HR2470 SDS-Plus fúrókalapács',
    description: '780W, 2.4J ütési energia',
    category: ItemCategory.POWER_TOOL,
    brand: 'Makita',
    unit: 'db',
    currentStock: 3,
    reservedStock: 1,
    availableStock: 2,
    minStock: 4,
    maxStock: 10,
    purchasePrice: 42000,
    sellingPrice: 54990,
    rentalPriceDaily: 4500,
    vatRate: 27,
    warehouseId: 'wh1',
    warehouseName: 'Központi raktár',
    location: 'A-13-1',
    status: StockStatus.LOW_STOCK,
    isRentable: true,
    isSellable: true,
    lastStockUpdate: '2024-01-18T09:15:00',
  },
  {
    id: 'inv4',
    sku: 'BOS-GWS750',
    barcode: '3165140823302',
    name: 'Bosch GWS 750-125 Sarokcsiszoló',
    description: '750W Professional',
    category: ItemCategory.POWER_TOOL,
    brand: 'Bosch',
    unit: 'db',
    currentStock: 15,
    reservedStock: 0,
    availableStock: 15,
    minStock: 5,
    maxStock: 25,
    purchasePrice: 16000,
    sellingPrice: 21990,
    rentalPriceDaily: 1800,
    vatRate: 27,
    warehouseId: 'wh1',
    warehouseName: 'Központi raktár',
    location: 'A-12-6',
    status: StockStatus.IN_STOCK,
    isRentable: true,
    isSellable: true,
    lastStockUpdate: '2024-01-16T11:30:00',
  },

  // Kéziszerszámok
  {
    id: 'inv5',
    sku: 'STA-FMHT',
    barcode: '3253560336981',
    name: 'Stanley FatMax Mérőszalag 8m',
    category: ItemCategory.HAND_TOOL,
    brand: 'Stanley',
    unit: 'db',
    currentStock: 25,
    reservedStock: 0,
    availableStock: 25,
    minStock: 10,
    maxStock: 50,
    purchasePrice: 3200,
    sellingPrice: 4990,
    vatRate: 27,
    warehouseId: 'wh2',
    warehouseName: 'Üzlet raktár',
    location: 'B-5-2',
    status: StockStatus.IN_STOCK,
    isRentable: false,
    isSellable: true,
    lastStockUpdate: '2024-01-17T10:00:00',
  },
  {
    id: 'inv6',
    sku: 'KNA-COBA',
    barcode: '4003773066521',
    name: 'Knipex Cobra Vízpumpa fogó 250mm',
    category: ItemCategory.HAND_TOOL,
    brand: 'Knipex',
    unit: 'db',
    currentStock: 10,
    reservedStock: 0,
    availableStock: 10,
    minStock: 5,
    maxStock: 20,
    purchasePrice: 9500,
    sellingPrice: 12990,
    vatRate: 27,
    warehouseId: 'wh2',
    warehouseName: 'Üzlet raktár',
    location: 'B-6-1',
    status: StockStatus.IN_STOCK,
    isRentable: false,
    isSellable: true,
    lastStockUpdate: '2024-01-15T14:30:00',
  },

  // Tartozékok
  {
    id: 'inv7',
    sku: 'MAK-BL1850',
    barcode: '0088381464260',
    name: 'Makita BL1850B 18V 5.0Ah Akku',
    category: ItemCategory.ACCESSORY,
    brand: 'Makita',
    unit: 'db',
    currentStock: 20,
    reservedStock: 5,
    availableStock: 15,
    minStock: 10,
    maxStock: 40,
    purchasePrice: 24000,
    sellingPrice: 32990,
    vatRate: 27,
    warehouseId: 'wh1',
    warehouseName: 'Központi raktár',
    location: 'C-1-1',
    status: StockStatus.IN_STOCK,
    isRentable: false,
    isSellable: true,
    lastStockUpdate: '2024-01-18T07:45:00',
  },
  {
    id: 'inv8',
    sku: 'BOS-DISC125',
    barcode: '3165140594301',
    name: 'Bosch Vágókorong készlet 125mm 10db',
    category: ItemCategory.CONSUMABLE,
    brand: 'Bosch',
    unit: 'csomag',
    currentStock: 50,
    reservedStock: 0,
    availableStock: 50,
    minStock: 20,
    maxStock: 100,
    purchasePrice: 2100,
    sellingPrice: 2990,
    vatRate: 27,
    warehouseId: 'wh1',
    warehouseName: 'Központi raktár',
    location: 'C-3-2',
    status: StockStatus.IN_STOCK,
    isRentable: false,
    isSellable: true,
    lastStockUpdate: '2024-01-16T13:20:00',
  },

  // Munkaruha
  {
    id: 'inv9',
    sku: 'SNI-BOOT42',
    barcode: '5901234567890',
    name: 'Munkavédelmi bakancs S3 42-es',
    category: ItemCategory.WORKWEAR,
    brand: 'Snickers',
    unit: 'pár',
    currentStock: 0,
    reservedStock: 0,
    availableStock: 0,
    minStock: 3,
    maxStock: 10,
    purchasePrice: 11000,
    sellingPrice: 15990,
    vatRate: 27,
    warehouseId: 'wh2',
    warehouseName: 'Üzlet raktár',
    location: 'D-1-1',
    status: StockStatus.OUT_OF_STOCK,
    isRentable: false,
    isSellable: true,
    lastStockUpdate: '2024-01-12T09:00:00',
  },

  // Alkatrész
  {
    id: 'inv10',
    sku: 'MAK-CB430',
    barcode: '0088381418874',
    name: 'Makita CB-430 Szénkefe pár',
    description: 'Sarokcsiszolóhoz, fúrókalapácshoz',
    category: ItemCategory.SPARE_PART,
    brand: 'Makita',
    unit: 'pár',
    currentStock: 35,
    reservedStock: 2,
    availableStock: 33,
    minStock: 15,
    maxStock: 60,
    purchasePrice: 1200,
    sellingPrice: 1990,
    vatRate: 27,
    warehouseId: 'wh1',
    warehouseName: 'Központi raktár',
    location: 'C-5-3',
    status: StockStatus.IN_STOCK,
    isRentable: false,
    isSellable: true,
    lastStockUpdate: '2024-01-17T15:00:00',
  },
];

export const MOCK_MOVEMENTS: StockMovement[] = [
  {
    id: 'mov1',
    itemId: 'inv1',
    itemName: 'Makita DHP486 Akkus fúró-csavarozó',
    itemSku: 'MAK-DHP486',
    type: MovementType.OUT,
    quantity: -1,
    previousStock: 13,
    newStock: 12,
    reference: 'R-2024-0089',
    note: 'Bérlés kiadás',
    createdBy: 'u1',
    createdByName: 'Tóth Anna',
    createdAt: '2024-01-18T08:30:00',
  },
  {
    id: 'mov2',
    itemId: 'inv7',
    itemName: 'Makita BL1850B 18V 5.0Ah Akku',
    itemSku: 'MAK-BL1850',
    type: MovementType.OUT,
    quantity: -2,
    previousStock: 22,
    newStock: 20,
    reference: 'S-2024-0145',
    note: 'Eladás',
    createdBy: 'u1',
    createdByName: 'Tóth Anna',
    createdAt: '2024-01-18T07:45:00',
  },
  {
    id: 'mov3',
    itemId: 'inv3',
    itemName: 'Makita HR2470 SDS-Plus fúrókalapács',
    itemSku: 'MAK-HR2470',
    type: MovementType.IN,
    quantity: 5,
    previousStock: 0,
    newStock: 5,
    reference: 'PO-2024-0034',
    note: 'Árubevételezés - Makita Kft.',
    createdBy: 'u2',
    createdByName: 'Kiss Gábor',
    createdAt: '2024-01-17T14:30:00',
  },
  {
    id: 'mov4',
    itemId: 'inv8',
    itemName: 'Bosch Vágókorong készlet 125mm 10db',
    itemSku: 'BOS-DISC125',
    type: MovementType.ADJUSTMENT,
    quantity: -3,
    previousStock: 53,
    newStock: 50,
    note: 'Leltár korrekció - sérült termékek',
    createdBy: 'u2',
    createdByName: 'Kiss Gábor',
    createdAt: '2024-01-16T13:20:00',
  },
  {
    id: 'mov5',
    itemId: 'inv1',
    itemName: 'Makita DHP486 Akkus fúró-csavarozó',
    itemSku: 'MAK-DHP486',
    type: MovementType.RETURN,
    quantity: 1,
    previousStock: 12,
    newStock: 13,
    reference: 'R-2024-0082',
    note: 'Bérlés visszavétel',
    createdBy: 'u1',
    createdByName: 'Tóth Anna',
    createdAt: '2024-01-16T11:00:00',
  },
];

export const CATEGORY_LABEL_KEYS: Record<ItemCategory, string> = {
  [ItemCategory.POWER_TOOL]: 'inventory.category.powerTool',
  [ItemCategory.HAND_TOOL]: 'inventory.category.handTool',
  [ItemCategory.ACCESSORY]: 'inventory.category.accessory',
  [ItemCategory.CONSUMABLE]: 'inventory.category.consumable',
  [ItemCategory.WORKWEAR]: 'inventory.category.workwear',
  [ItemCategory.SPARE_PART]: 'inventory.category.sparePart',
};

export const STATUS_LABELS: Record<StockStatus, { labelKey: string; color: string }> = {
  [StockStatus.IN_STOCK]: {
    labelKey: 'inventory.stockStatus.inStock',
    color: 'bg-green-100 text-green-700',
  },
  [StockStatus.LOW_STOCK]: {
    labelKey: 'inventory.stockStatus.lowStock',
    color: 'bg-yellow-100 text-yellow-700',
  },
  [StockStatus.OUT_OF_STOCK]: {
    labelKey: 'inventory.stockStatus.outOfStock',
    color: 'bg-red-100 text-red-700',
  },
  [StockStatus.DISCONTINUED]: {
    labelKey: 'inventory.stockStatus.discontinued',
    color: 'bg-gray-100 text-gray-700',
  },
};

export const MOVEMENT_LABELS: Record<MovementType, { labelKey: string; color: string }> = {
  [MovementType.IN]: { labelKey: 'inventory.movement.in', color: 'text-green-600' },
  [MovementType.OUT]: { labelKey: 'inventory.movement.out', color: 'text-red-600' },
  [MovementType.ADJUSTMENT]: {
    labelKey: 'inventory.movement.adjustment',
    color: 'text-orange-600',
  },
  [MovementType.TRANSFER]: { labelKey: 'inventory.movement.transfer', color: 'text-blue-600' },
  [MovementType.RETURN]: { labelKey: 'inventory.movement.return', color: 'text-purple-600' },
};
